<template>
    <div v-if="wrapper" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center block p-0">
            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0">
                <div v-show="show" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-white opacity-100"></div>
                </div>
            </transition>

            <span class="hidden inline-block align-middle h-screen"></span>&#8203;

            <h2 v-if="show" @click="$emit('close')" class="cursor-pointer absolute top-0 right-0 pt-6 pr-6 text-right font-light">
                <i class="fa fa-times" />
            </h2>

            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0 translate-y-4 translate-y-0 scale-95"
                enter-to-class="opacity-100 translate-y-0 scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 scale-100"
                leave-to-class="opacity-0 translate-y-4 translate-y-0 scale-95">
                <div v-show="show" class="transform transition-all" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <a href="/account/dashboard" class="no-underline">
                        <h2 class="mb-12 font-medium">Home</h2>
                    </a>
                    <a data-testid="account-profile" href="/account/profile" class="no-underline">
                        <h2 class="mb-12 font-medium">Profile</h2>
                    </a>
                    <a href="/account/account" class="no-underline">
                        <h2 class="mb-12 font-medium">Account</h2>
                    </a>
                    <form method="POST" action="/logout">
                        <button type="submit" class="no-underline">
                            <h2 class="font-medium text-gray-400">Logout</h2>
                        </button>
                    </form>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['account', 'open'],

        watch: {
            open(open, oldOpen) {
                if (open && ! oldOpen) {
                    this.wrapper = true;

                    setTimeout(() => {
                        this.show = true;
                    }, 100);
                } else if (! open && oldOpen) {
                    this.show = false;

                    setTimeout(() => {
                        this.wrapper = false;
                    }, 500);
                }
            }
        },

        data() {
            return {
                wrapper: false,
                show: false
            }
        }
    }
</script>